/* ============================================================
   WORKSPACE v4 (prototaip design) — media kad style
   ============================================================
   15 Okt 2026: pratonton video besar dibuang bersama sambungan server
   (page kini prototaip UI/UX sahaja — lihat utils/generateV2.js).
   Tiga keadaan satu kad style, ikut apa yang admin sudah isi pada
   preset itu di Prompt Library (medan `videoPratonton` / `poster`):

     1. ada video   → video main sendiri, senyap, berulang — SAMA seperti
                      kad formula Generate lama. Butang kecil membukanya
                      besar dengan kawalan + bunyi.
     2. ada poster  → gambar thumbnail.
     3. tiada apa   → POSTER REKAAN: ikon cara ia dirakam + rentak cerita
                      style itu. Ia jujur (tidak berpura-pura ada video)
                      dan tetap memberitahu apa yang pelanggan akan dapat.

   Bila admin mengisi URL di Prompt Library, kad bertukar sendiri —
   tiada kod perlu disentuh.
   ============================================================ */

import {
    Hand, MessageCircle, Package, Clapperboard, Camera, Sun, ZoomIn, Sparkles, Shirt, Film,
} from 'lucide-react';
import { labelRentak } from '../utils/generateV2';

/* Ikon ikut Presentation Style (id benih). Style ciptaan admin jatuh ke ikon filem. */
const IKON_GAYA = {
    'pov-hands': Hand,
    'ugc-talking-head': MessageCircle,
    'product-only': Package,
    'cinematic-showcase': Clapperboard,
    'multi-angle-demo': Camera,
    'lifestyle-ugc': Sun,
    'macro-detail': ZoomIn,
    'asmr-visual': Sparkles,
    'model-showcase': Shirt,
};

function PosterRekaan({ cerita, gaya }) {
    const Ikon = IKON_GAYA[gaya?.id] || Film;
    const langkah = labelRentak(cerita?.rentak, 5);
    return (
        <span className="gv2-poster">
            <span className="gv2-poster__ikon"><Ikon size={16} strokeWidth={1.8} /></span>
            <span className="gv2-poster__gaya">{gaya?.nama || 'Style'}</span>
            <span className="gv2-poster__rentak">
                {langkah.map((x, i) => (
                    <span key={i} className="gv2-poster__langkah"><i>{i + 1}</i><span>{x}</span></span>
                ))}
            </span>
        </span>
    );
}

export function MediaStyle({ preset, cerita, gaya }) {
    if (preset?.videoPratonton) {
        return <video src={preset.videoPratonton} poster={preset.poster || undefined} autoPlay muted loop playsInline preload="metadata" />;
    }
    /* ⛔ Tiada `loading="lazy"` — petak ini `place-items: center`; imej yang belum dimuat
       bersaiz 0×0 dan Chrome tidak pernah mencetuskan lazy-load untuknya (nota asal dalam
       GaleriFormula, PromptComposerV39.jsx). */
    if (preset?.poster) return <img src={preset.poster} alt="" />;
    return <PosterRekaan cerita={cerita} gaya={gaya} />;
}
